var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAs3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41658 5.5003C4.43278 4.29745 5.6309 3.24986 6.97507 2.39833C9.4514 0.829345 12.3166 0 15.2607 0C19.4009 0 23.2933 1.61228 26.2209 4.53985C29.1485 7.46742 30.7607 11.3598 30.7607 15.5C30.7607 19.6402 29.1485 23.5327 26.2209 26.4602C23.2933 29.3877 19.4009 31 15.2607 31C12.0796 31 9.02236 30.0431 6.41938 28.2326C3.8779 26.4648 1.94116 24.0115 0.818615 21.138L4.34287 19.7612C6.1119 24.29 10.3976 27.2164 15.2608 27.2164C21.7213 27.2164 26.9773 21.9604 26.9773 15.4999C26.9773 9.03931 21.7212 3.78343 15.2607 3.78343C11.9907 3.78343 8.96681 5.11205 6.79498 7.38948L10.9131 9.69256L5.54214 12.8922L0.171118 16.0921L0.0856743 9.84085L-4.00543e-05 3.58961L3.41658 5.5003Z",
    fill: "#33ca8f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAs3);
export default __webpack_public_path__ + "static/media/as3.1b93cb9a49571cf2959a5f6ae69daf25.svg";
export { ForwardRef as ReactComponent };